import { useEffect } from "react";

import { DOM_EVENTS, KEYBOARD_KEYS } from "@/constants/dom";

type UseEscapeKeyOptions = {
  readonly isActive: boolean;
  readonly onEscape: (event: KeyboardEvent) => void;
};

export default function useEscapeKey({ isActive, onEscape }: UseEscapeKeyOptions): void {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      // A composing IME or a widget that already handled the key keeps the dialog open.
      if (event.key !== KEYBOARD_KEYS.ESCAPE || event.isComposing || event.defaultPrevented) {
        return;
      }
      onEscape(event);
    };

    document.addEventListener(DOM_EVENTS.KEYDOWN, handleKeyDown);
    return () => {
      document.removeEventListener(DOM_EVENTS.KEYDOWN, handleKeyDown);
    };
  }, [isActive, onEscape]);
}
